import order_page from './_order.js'
import product_static_page from './_product_static_page.js'
import accountconfig_page from './_accountconfig.js'
import financial_page from './_financial.js'
import workorder_page from './_workorder.js'
import bought_page from './_bought.js'

function megarr(a, b) {
  for (var i in b) {
    a.push(b[i])
  }
  return a
}

var def_page = [{
  path: 'desktop/:leftid',
  name: 'merchant_desktop',
  component: () => import('@/views/merchant/admin/desktop'),
  meta: {
    tpflag: 'merchant',
    title: '管理中心',
  }
}, {
  path: 'cashcoupon/:leftid',
  name: 'merchant_cashcoupon',
  component: () => import('@/views/merchant/admin/cashcoupon/list'),
  meta: {
    tpflag: 'merchant',
    title: '现金券',
  }
}, {
  path: 'memberconfig/:leftid',
  name: 'merchant_memberconfig',
  component: () => import('@/views/merchant/setting/memberconfig/list'),
  meta: {
    tpflag: 'merchant',
    title: '成员管理',
  }
}]

def_page = megarr(def_page, order_page)
def_page = megarr(def_page, product_static_page)
def_page = megarr(def_page, accountconfig_page)
def_page = megarr(def_page, financial_page)
def_page = megarr(def_page, workorder_page)
def_page = megarr(def_page, bought_page)

export default def_page



// WEBPACK FOOTER //
// ./src/router/user/_user_children.js